<template>
  <v-tooltip top color="transparent" max-width="460">
    <template v-slot:activator="{ on, attrs }">
      <span class="rl-tip" v-bind="attrs" v-on="on"><slot>{{ label }}</slot></span>
    </template>
    <div class="white-bg-tooltip small-tooltip p-3">
      <span class="tooltip-heading">{{ heading || label }}</span><br /><br />
      <span class="tooltip-discription">
        <div v-for="(line, i) in lines" :key="i" class="rl-tip-line">{{ line }}</div>
      </span>
    </div>
  </v-tooltip>
</template>

<script>
/** POP's white tooltip (v-tooltip, transparent, .white-bg-tooltip card) with a heading and one paragraph per line. */
export default {
  name: 'RateLimitsTip',
  props: {
    label: { type: String, default: '' },
    heading: { type: String, default: '' },
    lines: { type: Array, default: () => [] },
  },
}
</script>

<style lang="scss">
.rl-tip {
  cursor: help;
  border-bottom: 1px dotted #9aa6a8;
}
.rl-tip-line + .rl-tip-line {
  margin-top: 6px;
}
</style>
